import React, { useEffect, useState } from "react";
import { LibraryActions } from "../../../store/stores/library/LibraryStore.Actions";
import { ConditionResults } from "./ConditionResults";
import { ObjectFilter, ObjectFilterInitializer } from "../../../entities/filters/ObjectFilter";
import { ConditionFilter } from "../../../entities/filters/ConditionFilter";
import { ConditionViewer } from "./ConditionViewer";
import { Breadcrumbs } from "../navigation/BreadCrumbs";
import { ConditionsRoute, LibraryRootRoute } from "../navigation/LibraryRoutes";
import { Route, Routes, useLocation, useNavigate } from "react-router";
import { Loader } from "../../theming/loader/Loader";
import { useAppDispatch, useAppSelector } from "../../../store/configureStore";
import { ErrorNotification } from "../../notifications/Notification";
import { NameFilter } from "../../characters/items/filters/NameFilter";

export const ConditionsLibrary = () => {
    const { conditions, allConditionsLoaded, conditionsError } = useAppSelector(app => app.library);

    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!allConditionsLoaded) {
            dispatch(LibraryActions.loadConditions());
        }
    }, [dispatch, allConditionsLoaded]);

    const query = new URLSearchParams(location.search);
    const [filterState, setFilterState] = useState(ObjectFilter.CreateFilterFromQuery(query));
    const conditionFilter = new ConditionFilter(filterState);

    const search = (newState: ObjectFilterInitializer) => {
        conditionFilter.update(newState);
        const query = conditionFilter.generateQueryString();
        navigate(query, { replace: true });
        setFilterState(newState);
    }
        
    const filteredConditions = conditionFilter.filter(conditions);

    return (
        <Routes>
            <Route path=":name" element={<ConditionViewer />} />
            <Route path="*" element={
                <>
                    {conditionsError && <ErrorNotification>There was an error loading conditions, you can try refreshing the page to reload them.</ErrorNotification>}
                    
                    <Breadcrumbs crumbs={[LibraryRootRoute, ConditionsRoute]} />
                    <h1>Conditions</h1>
                    <div className="filters">
                        <NameFilter name={filterState.name} onChange={name => search({ ...filterState, name })}></NameFilter>
                    </div>
                    {allConditionsLoaded && <ConditionResults conditions={filteredConditions} />}
                    {!allConditionsLoaded && <Loader>Loading Conditions</Loader>}
                </>
            } />
        </Routes>
    )
}